import React, { Component } from "react";
import tournamentStatus from "../../constants/TournamentStatus";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

class TournamentStatusContainer extends Component {
  state = {
    tournamentStatus: {}
  };

  handleTournamentStatusChange = e => {
    e.preventDefault();
    let tournamentStatus = this.state.tournamentStatus;
    tournamentStatus["status"] = e.target.value;
    const db = window.firebase.firestore();

    let batch = db.batch();

    batch.set(
      db.collection("tournamentStatus").doc(this.props.tournamentId),
      tournamentStatus
    );

    batch.update(db.collection("tournaments").doc(this.props.tournamentId), {
      status: e.target.value
    });

    batch.commit();
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("tournamentStatus")
      .doc(this.props.tournamentId)
      .onSnapshot(doc => {
        let tournamentStatus = doc.data();
        this.setState({ tournamentStatus: tournamentStatus || {} });
      });
  };

  render() {
    return (
      <Select
        style={{ maxWidth: "100%" }}
        value={this.state.tournamentStatus.status || 0}
        onChange={this.handleTournamentStatusChange}
      >
        {Object.keys(tournamentStatus).map(key => {
          let item = tournamentStatus[key];
          return (
            <MenuItem key={key} value={Number(key)}>
              {item.name}
            </MenuItem>
          );
        })}
      </Select>
    );
  }
}

export default TournamentStatusContainer;
